<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <div v-if="$scopedSlots.before">
      <slot name="before"/>
    </div>
    <div id="gjs"></div>
  </b-form-group>
</template>

<script>

import grapes from 'grapesjs';
import GrapesjsBlocksBasic from 'grapesjs-blocks-basic';
import GrapesjsPresetWebpage from 'grapesjs-preset-webpage';
import GrapesjsPluginExport from 'grapesjs-plugin-export';
import GrapesjsPresetNewsletter from 'grapesjs-preset-newsletter';
import 'grapesjs/dist/css/grapes.min.css';

export default {
  components: {},
  props: {
    model: Object,
    attribute: String,
    label: String,
    errors: Array,
    placeholder: String,
    errorOnly: Boolean,
    height: String
  },
  data() {
    return {
      state: null,
      errorTxt: '',
      editor: null
    }
  },
  watch: {
    model: {
      handler() {
        this.state = null;
        this.errorTxt = '';
      }, deep: true
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      if (!this.errorOnly) {
        this.state = !hasErr;
      }
    }
  },
  methods: {
    change() {
      // let css = this.editor.getCss({ avoidProtected: true });
      // this.model[this.attribute] = '<style type="text/css">'+ css +'</style>' + this.editor.getHtml();
      this.model[this.attribute] = this.editor.Commands.get('gjs-get-inlined-html').run(this.editor);
    },
    setValue(val) {
      this.editor.addComponents(val);
    }
  },
  mounted() {
    let config = {
      selectorManager: { componentFirst: true },
      container: '#gjs',
      showOffsets: true,
      noticeOnUnload: false,
      storageManager: false,
      forceClass: false,
      fromElement: true,
      plugins: [
        GrapesjsBlocksBasic,
        GrapesjsPresetWebpage,
        GrapesjsPluginExport,
        GrapesjsPresetNewsletter
      ],
      pluginsOpts: {
        GrapesjsBlocksBasic: {flexGrid: true},
        GrapesjsPresetWebpage: {},
      },
    };
    if(this.height) {
      config.height = this.height;
    }
    this.editor = grapes.init(config);
    this.editor.on('change', this.change);
    this.editor.addComponents(this.model[this.attribute] ? this.model[this.attribute] : null);
  }

}
</script>